export const PARTNER_CONTACT_FORM_TEST_ID = {
  name: 'name',
  companyName: 'company-name',
  emailAddress: 'email-address',
  description: 'description',
  submitButton: 'submit-button',
};
